import React, { Component } from 'react';
import { Button, Col, Row } from 'reactstrap';

export class BiometricOption extends Component {
    static displayName = BiometricOption.name;

    constructor(props) {
        super(props);
    }


    render() {
        return (
            <div className="SignUpConfirmation">
                <h1 className="text-center">Placeholder H1</h1>
                <Row>
                    <Col sm={12} md={{ size: 6, offset: 3 }} >
                        <p>Would you like to set up face or fingerprint recognition on your device?</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} md={{ size: 3, offset: 3 }} className="text-center" >
                        <Button outline color="secondary" size="md" >Yes</Button>
                    </Col>
                    <Col xs={6} md={3} >
                        <Button outline color="secondary" size="md" >No thanks</Button>
                    </Col>
                </Row>
            </div>
        );
    }



}

